import { ServiceOptionsTableColumns } from '../../../serviceOrders/serviceOptions/table/ServiceOptionsTableColumns';
import { SortDirection, TableSort } from '../../../sharedComponents/table/SortedTableHeader';
import { ServiceOptionStatus } from '../../../serviceOrders/serviceOptions/serviceOption.types';
import { GetServiceOptionsQueryParams } from '../../serviceOptionsApi';
import { mapServiceTypesToApiServiceTypes } from './serviceTypeMapper';
import {
    ApiServiceOptionQueryParameter,
    ApiServiceOptionStatus,
    ServiceOptionApiSort,
} from '../../types/serviceOrder/serviceOptionsApi.types';

const mapServiceOptionStatusToApiServiceOptionStatus = (status: ServiceOptionStatus): ApiServiceOptionStatus => {
    switch (status) {
        case ServiceOptionStatus.OPEN:
            return ApiServiceOptionStatus.OPEN;
        case ServiceOptionStatus.CLOSED:
            return ApiServiceOptionStatus.CLOSED;
        case ServiceOptionStatus.CANCELLED:
            return ApiServiceOptionStatus.CANCELLED;
    }
};

const mapServiceOptionStatusesToApiStatuses = (
    statusFilter: ServiceOptionStatus[],
): ApiServiceOptionStatus[] | undefined =>
    statusFilter.length === 0 ? undefined : statusFilter.map(mapServiceOptionStatusToApiServiceOptionStatus);

export const mapToServiceOptionApiSort = (sorting: TableSort<ServiceOptionsTableColumns>): ServiceOptionApiSort => {
    const sortDirection = sorting.dir;
    if (sortDirection === SortDirection.ASCENDING) {
        switch (sorting.column) {
            case ServiceOptionsTableColumns.STATUS:
                return ServiceOptionApiSort.STATUS_ASC;
            case ServiceOptionsTableColumns.ORDER_ISSUE_DATE:
                return ServiceOptionApiSort.ORDER_ISSUED_AT_ASC;
            case ServiceOptionsTableColumns.LOCATION_ID:
                return ServiceOptionApiSort.LOCATION_IDENTIFIER_ASC;
        }
    } else if (sortDirection === SortDirection.DESCENDING) {
        switch (sorting.column) {
            case ServiceOptionsTableColumns.STATUS:
                return ServiceOptionApiSort.STATUS_DES;
            case ServiceOptionsTableColumns.ORDER_ISSUE_DATE:
                return ServiceOptionApiSort.ORDER_ISSUED_AT_DESC;
            case ServiceOptionsTableColumns.LOCATION_ID:
                return ServiceOptionApiSort.LOCATION_IDENTIFIER_DESC;
        }
    }
    throw new Error('forgot to implement mapper for sorting or column');
};

export const mapToServiceOptionQueryParameters = (
    queryParameters: GetServiceOptionsQueryParams,
): ApiServiceOptionQueryParameter => ({
    statuses: queryParameters.statuses && mapServiceOptionStatusesToApiStatuses(queryParameters.statuses),
    service_types: queryParameters.serviceTypes && mapServiceTypesToApiServiceTypes(queryParameters.serviceTypes),
    order_issued_at_after: queryParameters.orderIssuedAtAfter?.toISOString(),
    order_issued_at_before: queryParameters.orderIssuedAtBefore?.toISOString(),
    service_location: queryParameters.location,
    q: queryParameters.searchTerm,
    sort: queryParameters.sortBy && mapToServiceOptionApiSort(queryParameters.sortBy),
    limit: queryParameters.limit,
});
